/**
 * 成片字幕条的像素 ↔ 归一化换算(VID-D)。
 *
 * ★单独抽在 shared 层,是因为 jsdom 里 react-rnd 的 `bounds="parent"` 会把落点钳到 0
 * (父元素 getBoundingClientRect 全 0),组件层根本测不出「拖了多远」—— 那条断言曾经
 * 绿得毫无意义。真实拖动距离只能靠浏览器 e2e 证;这里锁的是**换算公式**本身。
 */

/** 画布像素落点(条的**上沿**)→ 归一化 anchorY(字幕行**中心**占画面高的比例)。 */
export function pxToAnchorY(topPx: number, bandHeightPx: number, canvasH: number): number {
  if (!(canvasH > 0)) return 0;
  return clamp01((topPx + bandHeightPx / 2) / canvasH);
}

/** 归一化 anchorY → 条上沿的像素位置(渲染方向,与上式互逆)。 */
export function anchorYToPx(anchorY: number, bandHeightPx: number, canvasH: number): number {
  return Math.round(anchorY * canvasH - bandHeightPx / 2);
}

/** 手柄拉出来的宽度(px)→ 归一化占比,钳在 0.3~1(太窄会逐字换行成一根竖条)。 */
export function pxToWidthPct(widthPx: number, canvasW: number): number {
  if (!(canvasW > 0)) return 1;
  return Math.min(1, Math.max(0.3, widthPx / canvasW));
}

function clamp01(v: number): number {
  return Math.min(1, Math.max(0, v));
}
